import { selector } from "recoil";
import Config from "../flag-config/";

export const configSettings = selector({
  key: "config",
  get: () => Config
})
